<template>
  <div class="page">
    <div
      class="option-group"
      v-for="(pricingOption, index) in pricingOptions"
      :key="index"
    >
      <div class="mt-2">
        <div
          v-for="(variant, variantIndex) in pricingOption.variants"
          :key="`${index}-${variantIndex}`"
        >
          <div class="row">
            <label>{{ variant.option }} - {{ variant.variant }}</label>
            <h6 class="text-sale" v-show="variant.isSale">ลดราคา</h6>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-end mb-1">
        <el-checkbox
          class="col-2 center"
          v-model="pricingOption.isSell"
        >เปิดให้ลูกบ้านซื้อได้</el-checkbox>
        <el-checkbox
          class="col-2 center"
          v-model="pricingOption.isSale"
          @change="handleChangeIsSale(index, $event)"
          :disabled="!pricingOption.isSell"
        >ลดราคา</el-checkbox>
        <div class="col-12 row justify-content-end" v-show="pricingOption.isSale">
          <label class="col-2 center">ราคาเต็ม</label>
          <div class="col-3">
            <el-input
              type="number"
              min="0"
              :value="pricingOption.originalPrice"
              :disabled="!pricingOption.isSell"
              @input="handleInput(index, 'originalPrice', $event)"
            ></el-input>
          </div>
          <label class="col-2 center">ราคาลด</label>
          <div class="col-3">
            <el-input
              type="number"
              min="0"
              :value="pricingOption.price"
              :disabled="!pricingOption.isSell"
              @input="handleInput(index, 'price', $event)"
            ></el-input>
          </div>
        </div>
        <div class="col-12 row justify-content-end" v-show="!pricingOption.isSale">
          <label class="col-1 center">ราคา</label>
          <div class="col-3">
            <el-input
              type="number"
              min="0"
              :value="pricingOption.price"
              :disabled="!pricingOption.isSell"
              @input="handleInput(index, 'price', $event)"
            ></el-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton";
import { Input, Select, Option, Checkbox } from "element-ui";
import { isNil, isEmpty } from "ramda";

export default {
  components: {
    ScButton,
    ElInput: Input,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox
  },
  props: ["value"],
  data() {
    return {};
  },
  computed: {
    pricingOptions() {
      return this.value;
    }
  },
  methods: {
    handleInput(index, name, event) {
      const pricings = this.value.map((pricing, i) =>
        i === index ? { ...pricing, [name]: +event } : pricing
      );

      this.$emit("input", pricings);
    },
    handleChangeIsSale(index, event) {
      const pricings = this.value.map((pricing, i) =>
        i === index ? { ...pricing, originalPrice: event ? 0 : null } : pricing
      );

      this.$emit("input", pricings);
    }
  }
};
</script>

<style lang="scss" scoped>
.page {
  max-height: 500px;
  overflow: auto;
}

.text-sale {
  color: red;
  font-size: 13px;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.option-group {
  padding: 6px 30px 6px 30px;

  &:nth-child(2n) {
    background: rgb(236, 236, 236);
  }
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/packages/components/PackagePricingEditor.vue